import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ShopComponent } from '../../shop/shop.component';
import { Router } from '@angular/router';


@Component({
  selector: 'lc-order-page',
  templateUrl: './order-page.component.html',
  styleUrls: ['./order-page.component.scss']
})
export class OrderPageComponent implements OnInit {

	public my_orders: any = [];
  public my_order_by_type: any = {'ZOOM': [], 'SONICARE': []};
  public show_all: boolean = false;

  constructor(public dataService: DataService, public router: Router) { }

  ngOnInit() {
    try{ window['set_page_name']('order_page') }catch(e){};
  	if(!!this.dataService.subuser_info) {
			this.getOrders();
  	}
  	else {
  		this.router.navigate(['/']);
  	}
  }

  getOrders(){
  	    // get the orders
    this.dataService.getMyOrders(true).subscribe((orders)=>{

      for( let order of orders ){
        this.dataService.adjust_date_object(order);
        let cert = undefined;
        for( let item of order.items ){
          cert = this.dataService.cert_from_product(item.product_details);
          if( !!cert ) break;
        }
        if( this.dataService.main_brand != 'AVENT'){
          order.order_type = cert || "SONICARE";
          this.my_order_by_type[order.order_type].push( order );
        }
      }
      this.my_orders = orders;
    },(err) => {
      console.warn(err);
    },
    () => {
      console.debug('done fetching orders for user');
      console.debug(this.my_orders);
    });
  }

  downloadPdf() {
  	console.debug('start download order bill ...');
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/order-page/order-page.component.ts